export const valuePropNames = {
  CHECKED: 'checked',
}
